import React from 'react';

import { withRouter } from 'react-router-dom';
import Suspense from '../../Common/components/Suspense-component';

import { getSinglePharmacy } from '../epics-pharmacies';
import { getUserStatus } from '../../Users/epics-users';
import PharmacyDetails from '../component-pharmacy-details';

class PharmacyDetailsPage extends React.Component {
    getPharmacyDetails = () => {
        return getSinglePharmacy(this.props.match.params.pharmacyId);
    };

    render() {
        return (
            <Suspense
                apiCalls={{
                    pharmacyDetails: this.getPharmacyDetails,
                    userStatus: getUserStatus
                }}
            >
                <PharmacyDetails />
            </Suspense>
        );
    }
}

export default withRouter(PharmacyDetailsPage);



// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/containers/container-pharmacy-details.js